import styles from "./MasterUI.module.css";

import { SettingsWorkBox } from "../workBoxes/SettingsWorkBox";
import { useRef, useState } from "react";
import { MasterTopBar } from "./MasterTopBar";
import { useOuterClickManyTargets } from "@kalyzee/kast-web-sdk/web-components";

export const MasterUI = ({ children }: { children: React.ReactNode }) => {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const settingsBtnRef: React.RefObject<HTMLDivElement> = useRef(null);
  const settingsBoxRef: React.RefObject<HTMLDivElement> = useRef(null);

  useOuterClickManyTargets([settingsBtnRef, settingsBoxRef], () => {
    setSettingsOpen(false);
  });

  const renderSettingsOverlayWorkBox = () => {
    const classes = [styles.settingsBox];
    if (!settingsOpen) classes.push(styles.invisible);
    return (
      <SettingsWorkBox 
        containerRef={settingsBoxRef}
        className={classes.join(" ")}
        onClose={() => setSettingsOpen(false)}
      />
    );
  };
  
  return (
    <div className={styles.container}>
      <MasterTopBar
        onSettings={() => setSettingsOpen(v => !v)}
        settingsBtnRef={settingsBtnRef}
      />
      <div className={styles.content}>
        {children}
        {renderSettingsOverlayWorkBox()}
      </div>
    </div>
  );
};